import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { ActivityType } from "../../../../types";
import { getActivitiesByType } from "../utils";
import { useLessonForm } from "./LessonFormContext";
import ActivityCard from "./ActivityCard";
import PlanningSummaryPanel from "./PlanningSummaryPanel";

interface ActivityTabPaneProps {
  type: ActivityType;
}

const ActivityTabPane: React.FC<ActivityTabPaneProps> = ({ type }) => {
  const {
    lesson,
    addActivity,
    currentLessonId,
    planningSummaries,
    generatingPlanningSummaryType,
    handleGeneratePlanningSummary,
    handleChangePlanningSummaryText,
    planningSuperSummaries,
    generatingPlanningSuperSummaryType,
    handleGeneratePlanningSuperSummary,
    handleChangePlanningSuperSummaryText,
  } = useLessonForm();
  const activitiesOfType = getActivitiesByType(lesson, type);

  return (
    <div className="tab-content">
      {currentLessonId && (
        <>
          <PlanningSummaryPanel
            activityType={type}
            text={planningSummaries[type].text ?? ""}
            loading={generatingPlanningSummaryType === type}
            disabled={activitiesOfType.length === 0}
            onChangeText={(text) => handleChangePlanningSummaryText(type, text)}
            onGenerate={() => handleGeneratePlanningSummary(type)}
          />
          <PlanningSummaryPanel
            variant="superSummary"
            activityType={type}
            text={planningSuperSummaries[type].text ?? ""}
            stale={planningSuperSummaries[type].stale}
            loading={generatingPlanningSuperSummaryType === type}
            disabled={activitiesOfType.length === 0}
            onChangeText={(text) =>
              handleChangePlanningSuperSummaryText(type, text)
            }
            onGenerate={() => handleGeneratePlanningSuperSummary(type)}
          />
        </>
      )}
      {activitiesOfType.length === 0 ? (
        <div className="empty-activities">
          <p>No hay actividades para esta sección</p>
          <Button
            type="primary"
            onClick={() => addActivity(type)}
            icon={<PlusOutlined />}
            className="add-first-activity"
          >
            Añadir actividad
          </Button>
        </div>
      ) : (
        <>
          {activitiesOfType.map((activity, typeIndex) => (
            <ActivityCard
              key={activity.id}
              activity={activity}
              typeIndex={typeIndex}
              activityType={type}
            />
          ))}
          <Button
            type="dashed"
            onClick={() => addActivity(type)}
            icon={<PlusOutlined />}
            className="add-activity-button"
          >
            Añadir actividad
          </Button>
        </>
      )}
    </div>
  );
};

export default ActivityTabPane;
